module.exports = __webpack_public_path__ + "img/sergeant-reason-icon11.2f4b6739.png";